import React, {useEffect} from 'react';
import { Helmet } from "react-helmet";
import config from '../../config/config';

export default function ApplicationFunnel() {

    // dynamicaly adding script and link tag because of reloading issue
    useEffect(() => {
        // const delayExecution = setTimeout(() => {
          const script = document.createElement('script');
          script.src = `${config.appFunnelJsUrl}`;  
          const link = document.createElement('link');
          link.href = `${config.appFunnelCssUrl}`;
          link.rel = 'stylesheet';
    
          document.head.appendChild(script);
          document.head.appendChild(link);
        // }, 1000);
    
        // return () => clearTimeout(delayExecution);
      }, []);

    return (
        <div>
            <div className="calque-form-widget">
            </div>
        </div>
    )
}
